/**
 *  Common functions for Course enrollment logic
 *
 */


 export default {
    data() {
        return {
            showProgram: false
        }
    },
    methods: {
        showSoldOutFunc(course){//Not enrolled and (waitlist enabled is fulled or waitlist is disabled)
        	return !this.showInCourse(course) && (this.isWaitListEnabledFull(course) || (this.isWaitListDisabled(course) && course.soldout));
        },
        showWaitListFunc(course){//Not comming soon and not enrolled and (waitlist forced or waitlist enabled with capacity or waitlist is auto)
            return !this.showComingSoonFunc(course) && !this.showInCourse(course) && (this.isWaitListForced(course) || this.isWaitListEnabled(course) || this.isWaitListAuto(course));
        },       
        showWaitingFunc(course){//Not enrolled and is waitlist and user waitlist enrolled and (not process_by_admin or (process_by_admin && course soldout))
            return !this.showInCourse(course) && this.isWaitList(course) && !!course.user_in_wait_list && (!course.process_by_admin || (!!course.process_by_admin && course.soldout));
        },
        showFullFunc(course) {
            return !this.showInCourse(course) && this.isWaitListDisabled(course) && course.soldout;
        },
        showEnrollFunc(course){//Not comming soon and not enrolled and not soldout and (waitlist disabled or process_by_admin??)
            return !this.showComingSoonFunc(course) && !this.showInCourse(course) && ((this.isWaitList(course) && course.process_by_admin) || (this.isWaitList(course) && !this.isWaitListForcedTruth(course) && !course.soldout && (!course.current_users || (!!course.full_seats && !course.user_in_wait_list))) || (this.isWaitListDisabled(course) && !course.soldout));
        },
        showInCourse(course){
        	return course.hasOwnProperty('user_in_course') && !!JSON.parse(course.user_in_course);
        },
        showComingSoonFunc(course) {
            return course.hasOwnProperty('is_coming_soon') && !!JSON.parse(course.is_coming_soon);
        },
        isWaitListDisabled(course) {
            return !course.wait_list_type || (!!course.wait_list_type && course.wait_list_type === 'DISABLED');
        },
        isWaitList(course) {
            return !this.isWaitListDisabled(course);
        },
        isWaitListActive(course) {
            return this.isWaitList(course) && (!!course.full_seats || !!course.current_users) && (course.wait_list_type === 'AUTO' || course.wait_list_type === 'ENABLED');
        },
        isWaitListAuto(course) {
            return this.isWaitList(course) && (!!course.full_seats || !!course.current_users) && !course.user_in_wait_list && course.wait_list_type === 'AUTO';
        },
        isWaitListAutoTruth(course) {
            return this.isWaitList(course) && (!!course.full_seats || !!course.current_users) && course.wait_list_type === 'AUTO';
        },
        isWaitListEnabled(course) {
            return this.isWaitList(course) && (!!course.full_seats || !!course.current_users) && !course.user_in_wait_list && course.wait_list_type === 'ENABLED' && course.max_num_waiters > course.current_users;
        },
        isWaitListEnabledTruth(course) {
            return this.isWaitList(course) && (!!course.full_seats || !!course.current_users) && course.wait_list_type === 'ENABLED';
        },
        isWaitListEnabledFull(course) {
            return this.isWaitList(course) && (!!course.full_seats || !!course.current_users) && !course.user_in_wait_list && course.wait_list_type === 'ENABLED' && course.max_num_waiters <= course.current_users;
        },
        isWaitListForced(course) {
            return this.isWaitList(course) && course.wait_list_type === 'FORCE' && !course.user_in_wait_list;
        },
        isWaitListForcedTruth(course) {
            return this.isWaitList(course) && course.wait_list_type === 'FORCE'
        },
    }
};